import React from 'react'
import ContentArea from '../components/ContentArea'

const IntroRelaxPage = () => {
    return (
        <ContentArea>
            <h2>What is relaxation?</h2>
            <p>
                Practicing even a few minutes of relaxation techniques each day can provide a reserve of inner calm and support health and well-being. Using the breath is one technique for eliciting relaxation and guided imagery is another. Guided imagery is the art of harnessing the power of the mind and imagination to actually change your physical state. By using the power of your breath you can alter your body and mind and bring about greater peace and tranquility. You can use your thoughts to control your physiological reaction to stress. By using imagery and focusing your thoughts in a more relaxed and calming way you can change your heart rate, tension, and distress.
            </p>
        </ContentArea>
    )
}

export default IntroRelaxPage
